<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t('Entries') }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            v-if="$can('manage', 'All')"
            v-b-toggle.sidebar-create-district
            variant="primary"
          >
            {{ $t('Create') }}
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Search...')"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="districtTable"
      :items="list"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative"
    >
      <!-- Column: Id -->
      <template #head()="data">
        {{ $t(data.label) }}
      </template>
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <!-- Column: Id -->
      <template #cell(name)="data">
        {{ $langName(data.value) }}
      </template>
      <template #cell(region)="data">
        {{ $langName(data.value.name) }}
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label="Text Centered"
          />
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            v-if="$can('manage', 'All')"
            v-b-toggle.sidebar-create-district
            icon="EditIcon"
            class="cursor-pointer"
            size="16"
            @click="update(data.item)"
          />

          <feather-icon
            v-if="$can('manage', 'All')"
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="TrashIcon"
            size="16"
            class="mx-1 cursor-pointer"
            @click="remove(data.item)"
          />
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t("table summary", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }} </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>
      </b-row>
      <create @refetchData="refetchData" />
    </div>
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BSpinner,
  BTable, BPagination, VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import districtModule from '@/store/district/index'
import regionModule from '@/store/region/index'
import Create from './Create.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    vSelect,
    Create,
    BSpinner,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    this.$store.dispatch('region/list')
  },
  methods: {
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
  },
  setup() {
    const MODULE_NAME = 'district'
    const MODULE_REGION = 'region'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, districtModule)
    if (!store.hasModule(MODULE_REGION)) store.registerModule(MODULE_REGION, regionModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      ...config(),
    }
  },
}
</script>

<style lang="scss">
</style>
